import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import '../../assets/css/AmDropdownMenu.scss';
let default_1 = class default_1 extends Vue {
  constructor() {
    super(...arguments);
    this.iconClass = 'yxt-icon-arrow-down';
  }
  get panelStyle() {
    return {
      width: this.isCustom ? this.width : 'auto',
      minWidth: this.isCustom ? this.width : 'auto'
    };
  }
  get iconObj() {
    // 旧数据兼容（原为string类型）
    return this.icon ? typeof this.icon == 'string' ? JSON.parse(this.icon) : this.icon : {};
  }
  get iconType() {
    var _this$iconObj;
    return ((_this$iconObj = this.iconObj) === null || _this$iconObj === void 0 ? void 0 : _this$iconObj.iconType) || '';
  }
  get iconName() {
    var _this$iconObj2;
    return ((_this$iconObj2 = this.iconObj) === null || _this$iconObj2 === void 0 ? void 0 : _this$iconObj2.value) || '';
  }
  handleVisibleChange(visible) {
    if (!this.customElm) return;
    if (visible) this.iconClass = 'yxt-icon-arrow-up';else this.iconClass = 'yxt-icon-arrow-down';
  }
};
__decorate([Prop({
  type: String,
  default: '下拉菜单'
})], default_1.prototype, "title", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "customElm", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "isCustom", void 0);
__decorate([Prop(String)], default_1.prototype, "placement", void 0);
__decorate([Prop(String)], default_1.prototype, "trigger", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "hideOnClick", void 0);
__decorate([Prop(Boolean)], default_1.prototype, "disabled", void 0);
__decorate([Prop({
  default: 'primary'
})], default_1.prototype, "type", void 0);
__decorate([Prop(String)], default_1.prototype, "size", void 0);
__decorate([Prop({
  default: ''
})], default_1.prototype, "icon", void 0);
__decorate([Prop(String)], default_1.prototype, "width", void 0);
__decorate([Prop(Array)], default_1.prototype, "menuItems", void 0);
default_1 = __decorate([Component({
  name: 'AmDropdownMenuMixin'
})], default_1);
export default default_1;